// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Wq-z","breadcrumbForward":"Xq-z","breadcrumbBack":"Yq-z","selected":"Zq-z"};